import React from 'react';
import { useParams } from 'react-router-dom';
import { useInformationList } from '../residence/hooks';
import H2 from '../../components/Texts/H2';
import { useDocumentList } from './hooks';
import DocumentGroupBy from '../../components/Document/DocumentItem/DocumentGroupBy';
import styled from 'lib/styled';
import useGetSignedUrl from 'hooks/useGetSignedUrl';
import FeedImage from '../feed/components/FeedImage/FeedImage';
import { RawHtml } from '../../components/Layout/RawHtml';
import Breadcrumbs from '../../components/Breadcrumb/Breadcrumbs/Breadcrumbs';
import { L } from '@app/shared/lib/i18n';
import { medium } from 'lib/imageSize';
import { useGetProjectDetail } from 'hooks/projectQueries';

const ContentMain = styled.div({
    width: '100%',
    padding: '0px 0px 0px 0px',
    maxWidth: '60ch',
    marginBottom: '2rem',
    '& img': {
        maxWidth: '100%',
        width: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
    },
});
const StyledH2 = styled(H2)({
    marginTop: '0px',
});

const Wrapper = styled.div({
    paddingBottom: '3rem',
});

const StyledFeedImage = styled(FeedImage)({
    marginBottom: '1rem',
});

const HousingPagePost = ({ ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
    const { housingId, projectId } = useParams<{
        housingId: string;
        projectId: string;
    }>();

    const { data: info } = useInformationList(projectId);
    const { data: documents } = useDocumentList();
    const { data: project } = useGetProjectDetail(projectId);

    const informationItem = info?.find((item) => housingId && item.id === +housingId);
    const { data: FeedImgUrl } = useGetSignedUrl(informationItem?.cover_image_data, medium);

    if (!info || !documents || !housingId) return null;
    const title = info.find((item) => item.id === +housingId)?.title || '';
    return (
        <Wrapper {...rest}>
            <Breadcrumbs style={{ marginBottom: '2rem' }}>
                <Breadcrumbs.Item to={`/projects/${projectId}/housing`}>
                    {L('housing_about', project?.project_type)}
                </Breadcrumbs.Item>
                <Breadcrumbs.ItemActive>{title}</Breadcrumbs.ItemActive>
            </Breadcrumbs>
            <StyledH2>{info.find((item) => item.id === +housingId)?.title || ''}</StyledH2>
            <ContentMain>
                {FeedImgUrl && <StyledFeedImage url={FeedImgUrl} />}
                {informationItem?.description && <RawHtml content={informationItem.description} />}
            </ContentMain>

            <DocumentGroupBy documents={documents} />
        </Wrapper>
    );
};

export default HousingPagePost;
